import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import { mergeMap, map } from "rxjs/operators";
import { Principal } from "../shared/auth/principal.service";
import { ApiCallQueueingServiceBase } from "./api-call-queueing-service-base";

@Injectable()
export class CrewPermissionsService extends ApiCallQueueingServiceBase <Nema.Crew.Model.ApplicationUser> {

    constructor(principal: Principal)
    {
        super(() => principal.identity());
    }

    public isPermissionRead(): Observable<boolean> {
        return this.retrieveFromUserIdentity(userIdentity => userIdentity.PermissionRead);
    }

    public isPermissionWrite(): Observable<boolean> {
        return this.retrieveFromUserIdentity(userIdentity => userIdentity.PermissionWrite);
    }

    public isPermissionAdmin(): Observable<boolean> {
        return this.retrieveFromUserIdentity(userIdentity => userIdentity.PermissionAdmin);
    }

    public isPermissionWriteOrAdmin(): Observable<boolean> {
        return this.isPermissionWrite().pipe(
            mergeMap(write => write ? of(write) : this.isPermissionAdmin()));
    }

    public getPermissions(): Observable<CrewPermissions> {
        return this.retrieveFromUserIdentity(userIdentity => ({
            isPermissionRead: userIdentity.PermissionRead,
            isPermissionWrite: userIdentity.PermissionWrite,
            isPermissionAdmin: userIdentity.PermissionAdmin,
            isPermissionWriteOrAdmin: userIdentity.PermissionWrite || userIdentity.PermissionAdmin
        }));
    }

    private retrieveFromUserIdentity<T>(func: (userIdentity: Nema.Crew.Model.ApplicationUser) => T): Observable<T> {
        return this.retrieveOrWait().pipe(
            map(userIdentity => userIdentity ? func(userIdentity) : undefined));
    }
}

export interface CrewPermissions {
    isPermissionRead: boolean;
    isPermissionWrite: boolean;
    isPermissionAdmin: boolean;
    isPermissionWriteOrAdmin: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/crew-permissions.service.ts